export enum EnumMeioDeEnvio {
  SMS = 'SMS',
  SMS_TOTAL_VOICE = 'SMS_TotalVoice',
  SMS_TWW = 'SMS_TWW',
  SMS_ComTele = 'SMS_ComTel',
  Whatsapp = 'Whatsapp',
  CloudWhatsapp = 'CloudWhatsapp',
  Mock = 'Mock'
}
